<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
}
#app {
  width: 100%;
  height: 100%;
}
#nprogress .bar {
  background: #4875ae !important;
}
#nprogress .spinner-icon {
  display: none;
}
.line {
  border-top: 1px dashed rgb(144, 147, 153);
  width: 92%;
  margin: 0 auto;
}
.line100 {
  border-top: 1px dashed rgb(144, 147, 153);
  width: 100%;
  margin: 0 auto;
}
.submit {
  width: 50% !important;
  margin-top: 30px;
}
.submitGroup {
  margin-left: 0;
  margin-top: 65px;
  text-align: center;
}
</style>

